// extracted by mini-css-extract-plugin
export default {"badge":"SidebarNotifications_badge__cWrnV"};